import React from "react";

const ProgressBar = (props: any) => {
  const { completed } = props;

  const containerStyles = {
    margin: "20px 0 50px",
    height: 40,
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: 50,
    overflow: "hidden",
  };

  const fillerStyles = {
    height: "100%",
    margin: "0 -10px",
    width: `${completed}%`,
    backgroundColor: "#F5A500",
    "text-align": "right",
  };

  const labelStyles = {
    padding: 5,
    lineHeight: "40px",
    color: "#fff",
    "font-weight": "bold",
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
